{
  "LOGIN": {
    "TITLE": "Iniciar Sesión",
    "SUBTITLE": "Accede a tu cuenta para continuar",
    "EMAIL": "Email",
    "EMAIL_PLACEHOLDER": "tu@email.com",
    "EMAIL_REQUIRED": "El correo electrónico es requerido.",
    "EMAIL_INVALID": "Por favor ingresa un email válido.",
    "PASSWORD": "Contraseña",
    "PASSWORD_PLACEHOLDER": "••••••••",
    "PASSWORD_REQUIRED": "La contraseña es requerida.",
    "PASSWORD_MIN": "La contraseña debe tener al menos 6 caracteres.",
    "BUTTON_LOADING": "Cargando...",
    "BUTTON": "Login",
    "OR": "o",
    "NO_ACCOUNT": "¿No tienes una cuenta?",
    "REGISTER_HERE": "Regístrate aquí",
    "FORGOT_PASSWORD": "¿Has olvidado tu contraseña?",
    "TERMS_1": "Al iniciar sesión, aceptas nuestros",
    "TERMS_2": "Términos de Servicio",
    "TERMS_3": "y",
    "TERMS_4": "Política de Privacidad",
    "ERROR_GOOGLE": "No se pudo iniciar sesión con Google. Por favor, intente nuevamente.",
    "ERROR_PROFILE": "No se pudo cargar el perfil de usuario.",
    "ERROR_INVALID_CREDENTIALS": "Credenciales incorrectas. Por favor, intente nuevamente."
  },
  "REGISTER": {
    "TITLE": "Crear Cuenta",
    "SUBTITLE": "Únete a nuestra comunidad gratis",
    "NAME": "Nombre",
    "NAME_PLACEHOLDER": "Tu nombre completo",
    "NAME_REQUIRED": "El nombre es requerido.",
    "NAME_MIN": "El nombre debe tener al menos 4 caracteres.",
    "USERNAME": "Usuario",
    "USERNAME_PLACEHOLDER": "nombre_usuario",
    "USERNAME_REQUIRED": "El nombre de usuario es requerido.",
    "USERNAME_PATTERN": "Solo se permiten letras, números y guiones bajos.",
    "USERNAME_AVAILABLE": "✓ Nombre de usuario disponible",
    "CONFIRM_PASSWORD": "Confirmar Contraseña",
    "CONFIRM_REQUIRED": "La confirmación de la contraseña es requerida.",
    "PASSWORD_MISMATCH": "Las contraseñas no coinciden.",
    "TERMS_AGREE": "Acepto los",
    "TERMS_REQUIRED": "Debes aceptar los términos y condiciones para continuar.",
    "BUTTON_LOADING": "Creando cuenta...",
    "BUTTON": "Registrarse",
    "HAVE_ACCOUNT": "¿Ya tienes una cuenta?",
    "LOGIN_HERE": "Inicia sesión aquí",
    "PASSWORD_STRENGTH": {
      "WEAK": "Débil",
      "FAIR": "Regular",
      "GOOD": "Buena",
      "STRONG": "Fuerte",
      "DEFAULT": "Seguridad"
    }
  },
  "BANNER": {
    "SIDEBAR_ARIA": "Menú de Perfil",
    "MY_PROFILE": "Mi Perfil",
    "MY_CREATIONS": "Mis Creaciones",
    "SETTINGS": "Configuración",
    "LOGOUT": "Cerrar Sesión",
    "SEARCH_PLACEHOLDER": "Buscar proyectos",
    "BOLA_8": "Bola 8",
    "CREATE": "Crear",
    "PRO": "PRO",
    "UPGRADE_PRO": "Subir a Pro",
    "LOGO_ALT": "Logo de MyPlace",
    "PROFILE_ALT": "Perfil",
    "PROFILE_IMG_ALT": "Foto de perfil",
    "LOGIN": "Iniciar Sesión",
    "REGISTER": "Registrarse",
    "CONFIRM_LOGOUT": "¿Estás seguro de que deseas cerrar sesión?"
  },
  "ACCOUNT": {
    "BANNER_ALT": "Banner de usuario",
    "PROFILE_ALT": "Foto de perfil",
    "THUMBNAIL_ALT": "Miniatura",
    "FOLLOW": "Seguir",
    "FOLLOWING": "Siguiendo",
    "REPORT_USER": "Reportar Usuario",
    "ABOUT_ME": "Acerca de mí",
    "NO_BIO": "Sin biografía",
    "MORE_INFO": "Más información",
    "FOLLOWERS": "{{ count }} Seguidores",
    "JOINED_ON": "Se unió el {{ date }}",
    "JOINED_RECENTLY": "Se unió recientemente",
    "CREATIONS": "{{ count }} Creaciones",
    "SECTION_CREATIONS": "Creaciones",
    "SCROLL_LEFT": "Anterior",
    "SCROLL_RIGHT": "Siguiente",
    "SORT_NEWEST": "Más nuevo",
    "SORT_LIKED": "Más gustados",
    "SORT_OLDEST": "Más antiguos",
    "NOTIF_LOGIN_TITLE": "Inicia sesión",
    "NOTIF_VERIFY_TITLE": "Verifica tu email",
    "NOTIF_FOLLOW_LOGIN": "Debes iniciar sesión para seguir a otros usuarios.",
    "NOTIF_FOLLOW_VERIFY": "Necesitas verificar tu correo electrónico antes de seguir a otros usuarios.",
    "NOTIF_REPORT_LOGIN": "Debes iniciar sesión para reportar a un usuario.",
    "NOTIF_REPORT_VERIFY": "Necesitas verificar tu correo electrónico antes de reportar a un usuario."
  },
  "ACCOUNT_SETTINGS": {
    "TITLE": "Configuración de la Cuenta",
    "TAB_PROFILE": "Perfil",
    "TAB_SECURITY": "Seguridad",
    "NAME_LABEL": "Nombre",
    "BIO_LABEL": "Biografía",
    "THEME_LABEL": "Tema",
    "THEME_DARK": "Oscuro",
    "THEME_LIGHT": "Claro",
    "THEME_AUTO": "Automático",
    "SAVING": "Guardando...",
    "SAVE": "Guardar",
    "PROFILE_PICTURE_LABEL": "Foto de Perfil",
    "PROFILE_PICTURE_ALT": "Foto de Perfil",
    "BANNER_LABEL": "Banner",
    "BANNER_ALT": "Banner",
    "ADD_BIO": "Añade una biografía...",
    "ACCOUNT_SECTION": "Cuenta",
    "USERNAME_LABEL": "Nombre de usuario",
    "CHANGE_USERNAME": "Cambiar nombre de usuario",
    "EMAIL_LABEL": "Correo electrónico",
    "EMAIL_HINT": "Para cambiar tu correo ve a la pestaña de",
    "DELETE_ACCOUNT_BTN": "Eliminar Cuenta",
    "DELETE_ACCOUNT_HINT": "Esta acción es irreversible y eliminará todo tu contenido.",
    "SOCIAL_NETWORKS": "Redes Sociales",
    "YOUTUBE": "YouTube",
    "YOUTUBE_PLACEHOLDER": "https://youtube.com/",
    "FACEBOOK": "Facebook",
    "FACEBOOK_PLACEHOLDER": "https://facebook.com/",
    "X_PLACEHOLDER": "https://x.com/",
    "DISCORD": "Discord",
    "DISCORD_PLACEHOLDER": "https://discord.com/",
    "CHANGE_EMAIL_TITLE": "Cambiar correo electrónico",
    "CHANGE_EMAIL_DESC": "Para cambiar tu correo necesitamos que confirmes tu",
    "NEW_EMAIL_LABEL": "Nuevo correo",
    "CURRENT_PASSWORD_LABEL": "Contraseña actual",
    "UPDATING": "Actualizando...",
    "UPDATE_EMAIL": "Actualizar Correo",
    "CHANGE_PASSWORD_TITLE": "Cambiar contraseña",
    "CHANGE_PASSWORD_DESC": "Introduce tu contraseña actual y luego escribe la nueva contraseña.",
    "NEW_PASSWORD_LABEL": "Nueva contraseña",
    "CONFIRM_PASSWORD_LABEL": "Confirmar nueva contraseña",
    "UPDATE_PASSWORD": "Actualizar Contraseña",
    "DELETE_MODAL_PERMANENT": "Esta acción es",
    "DELETE_MODAL_PERMANENT_HIGHLIGHT": "permanente",
    "DELETE_MODAL_UNDONE": "y no se puede deshacer.",
    "DELETE_MODAL_WARNING": "Todos tus proyectos, ítems, comentarios, seguidores, emojis y datos asociados serán eliminados permanentemente.",
    "DELETE_CONFIRM_PASSWORD": "Confirma tu contraseña",
    "DELETE_GOOGLE_OPTIONAL": "(opcional para cuentas de Google)",
    "DELETE_PASSWORD_PLACEHOLDER": "Ingresa tu contraseña",
    "CANCEL": "Cancelar",
    "DELETING": "Eliminando...",
    "NOTIF_VERIFY_TITLE": "Verifica tu email",
    "NOTIF_VERIFY_ACTION": "Necesitas verificar tu correo electrónico antes de realizar esta acción.",
    "NAME_LENGTH_ERROR": "El nombre debe tener entre 3 y 30 caracteres.",
    "BIO_LENGTH_ERROR": "La biografía no puede exceder 200 caracteres.",
    "SAVE_PROFILE_ERROR": "Error al actualizar el perfil.",
    "URL_FORMAT_ERROR": "La URL debe comenzar con http:// o https://",
    "URL_YOUTUBE_ERROR": "La URL debe ser un enlace válido a YouTube.",
    "URL_FACEBOOK_ERROR": "La URL debe ser un enlace válido a Facebook.",
    "URL_X_ERROR": "La URL debe ser un enlace válido a X (Twitter).",
    "URL_DISCORD_ERROR": "La URL debe ser un enlace válido a Discord.",
    "URL_INVALID_ERROR": "La URL no tiene un formato válido.",
    "SOCIAL_SAVE_SUCCESS": "Redes sociales actualizadas exitosamente.",
    "SOCIAL_SAVE_ERROR": "No se pudieron actualizar las redes sociales.",
    "EMAIL_EMPTY_ERROR": "El correo electrónico no puede estar vacío.",
    "CURRENT_PASSWORD_ERROR": "Debes ingresar tu contraseña actual.",
    "EMAIL_UPDATE_SUCCESS": "Correo actualizado. Por favor verifica tu nueva dirección de correo.",
    "NOTIF_VERIFY_NEW_EMAIL_TITLE": "Verifica tu nuevo email",
    "NOTIF_VERIFY_NEW_EMAIL_MSG": "Se ha enviado un enlace de verificación a tu nuevo correo electrónico.",
    "EMAIL_UPDATE_ERROR": "El correo electrónico no pudo ser actualizado.",
    "NEW_PASSWORD_REQUIRED_ERROR": "Debes ingresar y confirmar la nueva contraseña.",
    "PASSWORD_MIN_ERROR": "La nueva contraseña debe tener al menos 6 caracteres.",
    "PASSWORD_MISMATCH_ERROR": "Las contraseñas no coinciden.",
    "PASSWORD_UPDATE_SUCCESS": "Contraseña actualizada exitosamente.",
    "PASSWORD_UPDATE_ERROR": "La contraseña no pudo ser actualizada.",
    "DELETE_PASSWORD_ERROR": "Por favor ingresa tu contraseña para confirmar.",
    "DELETE_ACCOUNT_ERROR": "No se pudo eliminar la cuenta. Intenta de nuevo."
  },
  "COMMENTS": {
    "LOADING": "Cargando comentarios...",
    "LOAD_MORE": "Cargar más comentarios",
    "WRITE_COMMENT": "Escribe un comentario...",
    "COMMENT_BTN": "Comentar",
    "SENDING": "Enviando...",
    "PROFILE_ALT": "Foto de perfil",
    "EDITED": "editado",
    "COPY": "Copiar",
    "EDIT": "Editar",
    "DELETE": "Eliminar",
    "REPORT": "Reportar",
    "HIDE_REPLIES": "Ocultar",
    "VIEW_REPLIES": "Mostrar",
    "REPLY": "Responder",
    "REPLY_BTN": "Responder",
    "CANCEL": "Cancelar",
    "SAVING": "Guardando...",
    "SAVE": "Guardar",
    "EDIT_PLACEHOLDER": "Edita tu comentario...",
    "WRITE_REPLY": "Escribe tu respuesta...",
    "REPLYING_TO": "Respondiendo a",
    "NOTIF_LOGIN_TITLE": "Inicia sesión",
    "NOTIF_ACTION_LOGIN": "Debes iniciar sesión para realizar esta acción.",
    "NOTIF_VERIFY_TITLE": "Verifica tu email",
    "NOTIF_ACTION_VERIFY": "Necesitas verificar tu correo electrónico antes de continuar.",
    "EDIT_ERROR": "Error al actualizar el comentario.",
    "DELETE_CONFIRM": "¿Estás seguro de que quieres eliminar este comentario?",
    "DELETE_ERROR": "Error al eliminar el comentario.",
    "SUBMIT_ERROR": "Error al enviar comentario. Inténtalo de nuevo.",
    "REPLY_ERROR": "Error al enviar respuesta."
  },
  "CONTACT": {
    "BACK_HOME": "Volver al inicio",
    "TITLE": "Contacto",
    "SUBTITLE": "Estamos aquí para ayudarte",
    "EMAIL_TITLE": "Correo Electrónico",
    "EMAIL_DESC": "Para consultas generales, soporte o reportes, escríbenos a:",
    "SOCIAL_TITLE": "Redes Sociales",
    "SOCIAL_DESC": "Síguenos y contáctanos en nuestras redes para estar al tanto de las novedades:",
    "SOCIAL_TWITTER": "𝕏 / Twitter",
    "SECURITY_TITLE": "Reportes de Seguridad",
    "SECURITY_DESC_1": "Si encuentras una vulnerabilidad de seguridad, por favor repórtala a",
    "SECURITY_DESC_2": "Nos comprometemos a responder con la mayor brevedad.",
    "DMCA_TITLE": "Reporte de Contenido (DMCA)",
    "DMCA_DESC_1": "Si crees que algún contenido en MyPlace infringe tus derechos de autor, envíanos un correo a",
    "DMCA_DESC_2": "con la siguiente información:",
    "DMCA_ITEM_1": "Identificación del contenido infractor (enlace directo).",
    "DMCA_ITEM_2": "Identificación del material protegido.",
    "DMCA_ITEM_3": "Tu información de contacto y declaración de buena fe."
  },
  "COOKIE_CONSENT": {
    "DESCRIPTION": "Usamos cookies para mantener tu sesión, recordar tus preferencias y mostrar anuncios personalizados. Al hacer clic en \"Aceptar todas\", aceptas el uso de todas las cookies. Puedes gestionarlas en tu",
    "PRIVACY_LINK": "Política de Privacidad",
    "ACCEPT": "Aceptar todas",
    "REJECT": "Rechazar"
  },
  "CREATE_PROJECT": {
    "TITLE": "Crear un nuevo Proyecto",
    "PROJECT_TITLE_LABEL": "Título del Proyecto:",
    "PROJECT_TITLE_REQUIRED": "El título es obligatorio.",
    "DESCRIPTION_LABEL": "Descripción:",
    "PROJECT_TYPE_TITLE": "Tipo de Proyecto",
    "PROJECT_TYPE_WORLD_CUP": "World Cup",
    "PROJECT_TYPE_TIERLIST": "Tierlist",
    "PROJECT_TYPE_KMK": "KMK",
    "NEXT": "Siguiente",
    "THUMBNAIL_TITLE": "Miniatura y Confirmación",
    "TITLE_DISPLAY": "Título:",
    "DESCRIPTION_DISPLAY": "Descripción:",
    "NOT_PROVIDED": "No proporcionada",
    "PROJECT_TYPE_DISPLAY": "Tipo de Proyecto:",
    "THUMBNAIL_LABEL": "Miniatura del Proyecto:",
    "SELECT_THUMBNAIL": "Seleccionar Miniatura",
    "SELECT_THUMBNAIL_HINT": "Selecciona una imagen desde tu computadora o ingresa una URL",
    "NO_THUMBNAIL": "Ninguna miniatura seleccionada",
    "RANDOM_TITLE": "Elementos Aleatorios",
    "RANDOM_DESC": "Cada usuario verá los elementos en orden aleatorio.",
    "HIGH_QUALITY_TITLE": "Miniatura de Alta Calidad",
    "HIGH_QUALITY_DESC_PRO": "Usar procesamiento adicional para mejorar la miniatura.",
    "HIGH_QUALITY_DESC_NON_PRO": "Actualiza a Pro para habilitar miniaturas de alta calidad.",
    "PRO_BADGE": "PRO",
    "BACK": "Volver",
    "CREATE": "Crear Proyecto",
    "ERROR_TITLE": "Error",
    "ERROR_TITLE_LENGTH": "El título debe tener entre 3 y 70 caracteres",
    "ERROR_DESC_LENGTH": "La descripción no puede exceder 200 caracteres",
    "ERROR_PRO_FEATURE": "La mejora de calidad de miniatura es una función exclusiva para usuarios Pro.",
    "ERROR_NO_IMAGE": "Debe proporcionar una imagen válida para la miniatura",
    "ERROR_CREATE": "Ocurrió un error al crear el proyecto. Por favor, inténtalo de nuevo.",
    "ERROR_UPLOAD": "El proyecto se creó pero hubo un error al subir la miniatura.",
    "ERROR_THUMBNAIL_URL": "El proyecto se creó pero hubo un error con la miniatura.",
    "ERROR_IMAGE_LOAD": "Error al cargar la imagen. Por favor, selecciona otra imagen desde el diálogo."
  },
  "EDIT_FORM": {
    "PUBLIC": "Público",
    "PRIVATE": "Privado",
    "CLICK_TO_ADD_THUMBNAIL": "Haz clic para agregar una miniatura",
    "UPDATING": "Actualizando...",
    "HD_THUMBNAIL": "Miniatura HD",
    "PRO_BADGE": "PRO",
    "ITEMS_TITLE": "Items:",
    "SEARCH_PLACEHOLDER": "Buscar items (Enter)...",
    "BULK_UPLOAD_TITLE": "Importación Masiva (PRO)",
    "TABLE_CONTENT": "Contenido",
    "TABLE_NAME": "Nombre",
    "TABLE_TYPE": "Tipo",
    "TABLE_ACTIONS": "Acciones",
    "SELECT_ALL": "Todos",
    "INVALID_URL": "URL inválida",
    "PAGINATION_PREV": "Atrás",
    "PAGINATION_NEXT": "Adelante",
    "ITEMS_SELECTED": "item(s) seleccionado(s)",
    "NO_SEARCH_RESULTS": "No se encontraron items que coincidan con",
    "NO_ITEMS": "No hay ningún item en este proyecto",
    "CLEAR_SELECTION": "Limpiar selección",
    "ITEM_NAME_LABEL": "Nombre del Item:",
    "CONTENT_LABEL": "Contenido:",
    "TYPE_YOUTUBE": "🎬 YouTube",
    "TYPE_IMAGE": "🖼️ Imagen",
    "CHANGE_IMAGE": "Cambiar Imagen/Video",
    "SELECT_IMAGE": "Seleccionar Imagen/Video",
    "INVALID_YOUTUBE_URL": "URL de YouTube inválida",
    "ENTER_VALID_URL": "Ingresa una URL válida",
    "SELECT_ITEM_TO_EDIT": "Selecciona un item para editar",
    "UPDATE": "Actualizar",
    "CANCEL": "Cancelar",
    "INSERT_NEW_ITEM": "Insertar Nuevo Item",
    "INSERT": "Insertar",
    "UPGRADE_TITLE": "Mejorar Miniatura",
    "UPGRADE_DESC": "¿Deseas subir imagenes de <strong>Alta Calidad (HD)</strong> para la miniatura de este proyecto?",
    "UPGRADE_PRO_DESC": "Esta acción usará tecnología de optimización PRO cuando subas una nueva imagen.",
    "UPGRADE_PROCESSING": "Procesando...",
    "UPGRADE_NOW": "Mejorar ahora",
    "BULK_IMPORTING": "Importando Imágenes...",
    "BULK_PROCESSING": "Estamos procesando y optimizando tus archivos. Por favor, no cierres esta ventana.",
    "BULK_ERROR_TITLE": "No se pudo subir estos archivos",
    "BULK_ERROR_DESC": "Los siguientes archivos no se pudieron subir:",
    "BULK_GOT_IT": "Entendido",
    "BULK_ERROR_UNKNOWN": "Error desconocido",
    "BULK_CHUNK_LABEL": "Lote #{{ chunk }}",
    "BULK_CHUNK_ERROR": "Error al procesar este lote de imágenes.",
    "BULK_NETWORK_ERROR": "No se pudo conectar con el servidor. Verifica tu conexión a internet e inténtalo de nuevo.",
    "ERROR_TITLE": "Error",
    "ERROR_PRO_TITLE": "Función PRO",
    "ERROR_VALIDATION_TITLE": "Validación",
    "ERROR_PRO_FEATURE": "Esta función es exclusiva para usuarios PRO. ¡Mejora tu cuenta para disfrutarla!",
    "ERROR_LOAD_PROJECT": "No se pudo cargar el proyecto.",
    "ERROR_LOAD_DATA": "No se pudieron cargar los datos. Verifica tu conexión.",
    "ERROR_ITEM_NAME_LENGTH": "El nombre del ítem debe tener entre 3 y 24 caracteres.",
    "ERROR_YOUTUBE_WORLD_CUP": "Los ítems de YouTube solo están permitidos en proyectos de tipo World Cup.",
    "ERROR_UPDATE_ITEM": "Error al actualizar el ítem o subir la imagen.",
    "ERROR_CREATE_ITEM": "Error al crear el ítem o subir la imagen.",
    "ERROR_GIF_TIERLIST": "No se permiten imágenes GIF para proyectos de tipo Tierlist.",
    "ERROR_MAX_50": "Puedes subir hasta 50 imágenes a la vez.",
    "ERROR_BULK_PROCESS": "Error al procesar la subida masiva.",
    "ERROR_UPGRADE_THUMBNAIL": "No se pudo mejorar la miniatura.",
    "SUCCESS_TITLE": "Éxito",
    "SUCCESS_IMPORT": "Se han importado {{ count }} ítems correctamente.",
    "INFO_TITLE": "Info",
    "INFO_NO_ITEMS": "No se importaron ítems.",
    "BULK_DELETE_CONFIRM": "¿Eliminar todos los items seleccionados? Esta acción no se puede deshacer.",
    "BULK_DELETE_ITEMS_SELECTED": "items seleccionados"
  },
  "EDIT_MODAL": {
    "TITLE": "Editar Proyecto",
    "NAME_LABEL": "Nombre del Proyecto",
    "NAME_PLACEHOLDER": "Ingresa el nombre del proyecto",
    "DESC_LABEL": "Descripción",
    "DESC_PLACEHOLDER": "Ingresa la descripción del proyecto",
    "STATUS_LABEL": "Estado",
    "STATUS_PUBLIC": "Público",
    "STATUS_PRIVATE": "Privado",
    "RANDOM_ITEMS": "Items aleatorios",
    "DELETE_BUTTON": "Eliminar Proyecto",
    "DELETING": "Eliminando proyecto...",
    "DELETE_DESC": "Esta acción eliminará el proyecto, todos sus items e imágenes permanentemente",
    "DELETE_TITLE": "Eliminar Proyecto",
    "DELETE_CONFIRM": "¿Estás seguro de que quieres eliminar este proyecto? Se eliminarán todos los items, imágenes y datos asociados. Esta acción no se puede deshacer.",
    "CANCEL": "Cancelar",
    "SAVE": "Guardar",
    "SAVING": "Guardando...",
    "ERROR_NAME_LENGTH": "El nombre del proyecto debe tener entre 3 y 50 caracteres.",
    "ERROR_DESC_LENGTH": "La descripción no puede superar 200 caracteres."
  },
  "EMOJI_PICKER": {
    "TITLE": "Seleccionar Emoji",
    "TAB_OWN": "Propios",
    "TAB_FAVORITES": "Favoritos",
    "LOADING_OWN": "Cargando emojis...",
    "LOADING_FAVORITES": "Cargando favoritos...",
    "EMPTY_OWN": "No has creado ningún emoji todavía.",
    "EMPTY_OWN_HINT": "Ve a Mis Creaciones para crear emojis.",
    "EMPTY_FAVORITES": "Todavía no tienes emojis favoritos.",
    "EMPTY_FAVORITES_HINT": "Puedes agregarlos desde los comentarios."
  },
  "EMOJI_DETAILS": {
    "DELETE": "Eliminar Emoji",
    "REMOVE_FAVORITE": "Quitar de Favoritos",
    "ADD_FAVORITE": "Agregar a Favoritos",
    "CANCEL": "Cancelar",
    "ERROR_DELETE": "Error al eliminar el emoji.",
    "ERROR_ADD_FAVORITE": "No se pudo agregar a favoritos.",
    "ERROR_ADD_FAVORITE_ALT": "Error al agregar a favoritos.",
    "ERROR_REMOVE_FAVORITE": "Error al quitar de favoritos."
  },
  "FOOTER": {
    "TAGLINE": "Crea, comparte y descubre el mejor contenido.",
    "TERMS": "Términos",
    "PRIVACY": "Privacidad",
    "CONTACT": "Contacto",
    "COPYRIGHT": "Todos los derechos reservados.",
    "MADE_WITH": "Hecho con",
    "MADE_WITH_END": "pasión."
  },
  "IMAGE_UPLOAD": {
    "TITLE_PROFILE": "Foto de Perfil",
    "TITLE_BANNER": "Banner",
    "TITLE_THUMBNAIL": "Miniatura del Proyecto",
    "TITLE_ITEM_TIERLIST": "Item para Tierlist",
    "TITLE_ITEM": "Item",
    "TAB_URL": "Usar URL",
    "TAB_UPLOAD": "Subir Archivo",
    "URL_PLACEHOLDER": "https://ejemplo.com/imagen.jpg",
    "YOUTUBE_READY": "🎬 YouTube URL lista para usarse",
    "CLICK_SELECT": "Haz clic para seleccionar archivo",
    "MAX_SIZE": "Máx: {{ size }}MB",
    "REMOVE_IMAGE_TITLE": "Quitar imagen",
    "CANCEL": "Cancelar",
    "UPLOADING": "Subiendo...",
    "UPLOAD_IMAGE": "Subir Imagen",
    "ERROR_GIF_TIERLIST": "No se permiten imágenes GIF para proyectos de tipo Tierlist.",
    "ERROR_FILE_TOO_LARGE": "El archivo es demasiado grande. Máximo {{ size }}MB",
    "ERROR_INVALID_URL": "Por favor ingresa una URL válida",
    "ERROR_UPLOAD_IMAGE": "Error al subir la imagen: {{ msg }}",
    "ERROR_UPLOAD_THUMBNAIL": "Error al subir la miniatura: {{ msg }}",
    "ERROR_MISSING_ID": "Falta el ID del proyecto",
    "ERROR_UPLOAD_ITEM": "Error al subir la imagen del item: {{ msg }}",
    "ERROR_SAVE_URL": "Error al guardar la URL: {{ msg }}",
    "ERROR_YOUTUBE_WORLD_CUP": "Los ítems de YouTube solo están permitidos en proyectos de tipo World Cup.",
    "ERROR_YOUTUBE_TIERLIST": "No se permiten videos de YouTube para Tierlists. Solo imágenes.",
    "ERROR_UNSUPPORTED_TYPE": "Este tipo no soporta subida por URL"
  },
  "ITEMS_TABLE": {
    "TITLE": "Lista de Items",
    "PREV": "Atrás",
    "NEXT": "Adelante"
  },
  "RANKING_TABLE": {
    "TITLE": "Clasificación",
    "NO_RESULTS": "Sin resultados",
    "CONTENT_ALT": "Contenido",
    "WIN_PERCENTAGE": "% de ganador",
    "ROUND_PERCENTAGE": "% supera de ronda",
    "PREV": "Atrás",
    "NEXT": "Adelante"
  },
  "TIERLIST": {
    "SEO_TITLE": "Tier list: {{ name }}",
    "NOT_AVAILABLE_DATE": "Fecha no disponible",
    "NEW_TIER": "Nuevo Tier",
    "DESCRIPTION_LABEL": "Descripción:",
    "NO_DESCRIPTION": "Sin Descripción",
    "CREATED_BY": "Creado por:",
    "PROFILE_ALT": "Imagen de perfil",
    "LAST_UPDATE": "Última actualización:",
    "SAVE": "Guardar",
    "IMAGE_ALT": "Imagen",
    "SCROLL_HINT": "← scroll →",
    "ALL_ASSIGNED": "Todos los ítems están asignados",
    "ROW_CONFIG_TITLE": "Configuración de fila",
    "TAB_EDIT": "Editar fila",
    "TAB_ACTIONS": "Acciones",
    "ADD_ROW_ABOVE": "Crear fila superior",
    "ADD_ROW_BELOW": "Crear fila inferior",
    "ROW_TEXT_LABEL": "Texto de la fila",
    "BG_COLOR_LABEL": "Color de fondo",
    "CANCEL": "Cancelar",
    "SAVE_ROW": "Guardar",
    "DELETE_ROW": "Eliminar fila",
    "LIMIT_TITLE": "Límite",
    "MAX_ROWS_LIMIT": "Un proyecto Tierlist no puede tener más de 10 filas.",
    "MIN_ROWS_LIMIT": "Un proyecto Tierlist debe tener al menos 2 filas."
  },
  "WORLD_CUP": {
    "LOADING": "Cargando...",
    "FINAL_ROUND": "Ronda Final",
    "ROUND_PROGRESS": "Ronda {{ current }}/{{ total }}",
    "SEO_TITLE": "Jugando: {{ name }}",
    "PREPARING": "Preparando enfrentamientos...",
    "WINNER_TITLE": "🏆 Ganador 🏆",
    "WINNER_ALT": "Imagen del ganador",
    "ACCEPT": "Aceptar",
    "ITEM_ALT": "Item image",
    "VS_ALT": "VS",
    "PHASE_PROGRESS": "Fase {{ display }} de {{ total }}"
  },
  "KMK": {
    "LOADING": "Preparando el juego...",
    "TITLE": "Kiss · Marry · Kill",
    "BATCH_PROGRESS": "Grupo {{ current }} de {{ total }}",
    "EMPTY_PLACEHOLDER": "— ° —",
    "ITEM_ALT": "Item",
    "NEXT": "Siguiente →",
    "NO_ITEMS": "No hay ítems disponibles para este proyecto.",
    "RESULTS_TITLE": "Tus resultados",
    "ROLE_KISS": "Kiss",
    "ROLE_MARRY": "Marry",
    "ROLE_KILL": "Kill",
    "LEGEND_KISS": "Kiss",
    "LEGEND_MARRY": "Marry",
    "LEGEND_KILL": "Kill",
    "PLAY_AGAIN": "🔄 Jugar de nuevo",
    "SEO_TITLE": "Kiss, Marry, Kill: {{ name }}"
  },
  "MY_CREATIONS": {
    "TITLE": "Mis Creaciones",
    "TAB_PROJECTS": "Proyectos",
    "TAB_EMOJIS": "Emojis",
    "SEARCH_PLACEHOLDER": "Buscar proyectos...",
    "SORT_CREATION_DATE": "Fecha de creación",
    "SORT_LAST_UPDATE": "Última actualización",
    "SORT_MOST_RECENT": "Más recientes",
    "SORT_OLDEST": "Más antiguos",
    "THUMBNAIL_ALT": "Miniatura",
    "ITEMS": "items",
    "PUBLIC": "Público",
    "PRIVATE": "Privado",
    "CREATE_PROJECT": "Crear Proyecto",
    "PAGINATION_PREV": "Atrás",
    "PAGINATION_NEXT": "Adelante",
    "PRO_BANNER_TITLE": "Los emojis personalizados son una función PRO",
    "PRO_BANNER_DESC": "Hazte PRO para crear emojis y usarlos en comentarios.",
    "PRO_BANNER_BUTTON": "Ver plan PRO",
    "MY_EMOJIS": "Mis Emojis",
    "ADD_EMOJI_TITLE": "Crear emoji",
    "ADD_EMOJI_LOCKED_TITLE": "Requiere plan PRO",
    "EMPTY_EMOJIS_PRO": "No has creado ningún emoji todavía.",
    "EMPTY_EMOJIS_NON_PRO": "Hazte PRO para crear tus propios emojis.",
    "FAVORITES_TITLE": "Favoritos",
    "EMPTY_FAVORITES": "Todavía no tienes emojis favoritos. Puedes agregarlos desde los comentarios.",
    "CREATE_EMOJI_MODAL_TITLE": "Crear Emoji",
    "PRO_BADGE": "PRO",
    "PRO_ONLY_TITLE": "Función exclusiva PRO",
    "PRO_ONLY_DESC": "Hazte PRO para crear emojis personalizados.",
    "CLOSE": "Cerrar",
    "PREVIEW_ALT": "Vista previa",
    "PREVIEW_PLACEHOLDER": "Vista previa",
    "SHORTCODE_LABEL": "Nombre del emoji (shortcode)",
    "SHORTCODE_PLACEHOLDER": "Ej: mi_emoji_favorito",
    "SHORTCODE_VALID": "Shortcode válido. Uso: ",
    "SHORTCODE_HINT": "Solo minúsculas, números y _ (mín. 3, máx. 20 caracteres)",
    "CANCEL": "Cancelar",
    "CREATING": "Creando...",
    "CREATE": "Crear",
    "NOTIF_PRO_REQUIRED": "Crear emojis requiere el plan PRO.",
    "ERROR_FILE_TYPE": "Tipo de archivo no válido. Usa JPG, PNG, GIF o WEBP.",
    "ERROR_MAX_SIZE": "Máximo 2MB.",
    "ERROR_GIF_SIZE": "Máximo 1.5MB para GIFs.",
    "ERROR_SHORTCODE_EMPTY": "El shortcode no puede estar vacío",
    "ERROR_SHORTCODE_MIN": "Mínimo 3 caracteres",
    "ERROR_SHORTCODE_MAX": "Máximo 20 caracteres",
    "ERROR_SHORTCODE_PATTERN": "Solo letras minúsculas, números y _",
    "ERROR_CREATE_EMOJI": "Error al crear la reacción",
    "ERROR_PRO_FEATURE": "Esta función requiere el plan PRO.",
    "ERROR_CONNECTION": "Error de conexión. Intenta nuevamente."
  },
  "PRIVACY": {
    "BACK_HOME": "Volver al inicio",
    "TITLE": "Política de Privacidad",
    "SUBTITLE": "Tu privacidad es nuestra prioridad",
    "SECTION_1_TITLE": "1. Datos Recolectados",
    "SECTION_1_HTML": "Recopilamos información básica como tu <b>correo electrónico</b> y <b>nombre de usuario</b> para gestionar tu cuenta. También almacenamos las configuraciones de tus minijuegos y tus mensajes en el chat para que tu experiencia sea persistente.",
    "SECTION_2_TITLE": "2. Uso de Cookies",
    "SECTION_2_INTRO": "Utilizamos cookies y tecnologías similares para los siguientes fines:",
    "SECTION_2_LI_ESSENTIAL": "<b>Cookies esenciales:</b> Mantener tu sesión activa y recordar tus preferencias visuales (como el modo oscuro).",
    "SECTION_2_LI_ADS": "<b>Cookies de publicidad:</b> Utilizamos <b>Google AdSense</b> y <b>DoubleClick</b> para mostrar anuncios personalizados basados en tus intereses. Estas cookies recopilan información sobre tu visita para generar anuncios relevantes.",
    "SECTION_2_TRACKING_HTML": "No rastreamos tu actividad fuera de nuestra plataforma. Puedes gestionar tus preferencias de cookies de publicidad a través de <a href=\"https://adssettings.google.com\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-blue-600 dark:text-blue-400 underline\">Google Ads Settings</a>.",
    "SECTION_3_TITLE": "3. Terceros y Google",
    "SECTION_3_INTRO": "No vendemos ni alquilamos tus datos a terceros. Los terceros con los que trabajamos son:",
    "SECTION_3_LI_GOOGLE": "<b>Google</b> — Inicio de sesión (OAuth 2.0) y publicidad (AdSense). Solo recibimos la información pública (email, nombre y avatar) que autorices para crear tu perfil.",
    "SECTION_3_LI_CLOUDINARY": "<b>Cloudinary</b> — Almacenamiento y optimización de imágenes.",
    "SECTION_3_DATA_USAGE_HTML": "<span class=\"font-medium text-blue-600 dark:text-blue-400\">Nuestro uso de la información recibida de las APIs de Google se ajustará a la Política de Datos de Usuario de los Servicios de API de Google, incluidos los requisitos de Uso Limitado.</span>",
    "SECTION_4_TITLE": "4. Eliminación de Datos",
    "SECTION_4_HTML": "En cualquier momento puedes solicitar la eliminación permanente de tu cuenta y todos los datos asociados desde tu panel de configuración. Al eliminar tu cuenta, todos tus datos personales son borrados de nuestros servidores de forma inmediata.",
    "SECTION_5_TITLE": "5. Publicidad y Google AdSense",
    "SECTION_5_HTML_1": "Utilizamos <b>Google AdSense</b> para mostrar anuncios en nuestra plataforma. Google AdSense utiliza cookies de DoubleClick para servir anuncios relevantes y medir su rendimiento. Como parte de la <b>Política de Consentimiento de Cookies de la UE</b> de Google, solicitamos tu consentimiento antes de cargar cookies de publicidad no esenciales.",
    "SECTION_5_HTML_2": "Puedes obtener más información sobre las prácticas de privacidad de Google en <a href=\"https://policies.google.com/privacy\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-blue-600 dark:text-blue-400 underline\">Política de Privacidad de Google</a> y gestionar tus preferencias de anuncios en <a href=\"https://adssettings.google.com\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-blue-600 dark:text-blue-400 underline\">Configuración de Anuncios de Google</a>.",
    "FOOTER_HTML": "Si tienes preguntas sobre cómo manejamos tus datos, contáctanos en <a href=\"mailto:support@myplacetoday.com\" class=\"text-blue-600 dark:text-blue-400 underline\">support@myplacetoday.com</a>."
  },
  "PRO_SHOP": {
    "BACK": "Volver",
    "SUBTITLE": "Lleva tu experiencia al siguiente nivel con funciones exclusivas y soporte prioritario.",
    "TAB_MY_SUBSCRIPTION": "Mi Suscripción",
    "TAB_GIFT": "Regalar PRO",
    "PLAN_LABEL": "Plan {{ label }}",
    "PLAN_TYPE_MONTHLY": "Mensual",
    "PLAN_TYPE_YEARLY": "Anual",
    "STATUS_ACTIVE": "Activa",
    "STATUS_PAUSED": "Pausada",
    "STATUS_CANCELLED": "Cancelada",
    "STATUS_PENDING": "Pendiente",
    "STATUS_NO_SUBSCRIPTION": "Sin suscripción",
    "STATUS_CANCELLED_ACCESS": "Acceso garantizado hasta el {{ date }}",
    "STATUS_NEXT_RENEWAL": "Próxima renovación: {{ date }}",
    "CHANGE_TITLE": "¿Quieres cambiar?",
    "CHANGE_DESC": "Puedes mejorar a un plan anual y ahorrar más.",
    "VIEW_OPTIONS": "Ver opciones",
    "CANCEL_TITLE": "¿Quieres cancelar?",
    "CANCEL_DESC": "Puedes cancelar tu suscripción. Seguirás con PRO hasta el final del periodo.",
    "CANCEL_BUTTON": "Cancelar",
    "CANCEL_OPTIONS_TITLE": "¿Qué prefieres hacer?",
    "SWITCH_TO_YEARLY": "Cambiar a plan anual",
    "SWITCH_TO_YEARLY_DESC": "Ahorra 20% y obtén 2 meses gratis",
    "CANCEL_SUBSCRIPTION": "Cancelar suscripción",
    "CANCEL_SUBSCRIPTION_DESC": "Seguirás con PRO hasta el {{ date }}",
    "CONFIRM_CANCEL_TITLE": "¿Cancelar suscripción?",
    "CONFIRM_CANCEL_DESC": "Perderás acceso a PRO el {{ date }} y no se te harán más cargos.",
    "GO_BACK": "Volver",
    "YES_CANCEL": "Sí, cancelar",
    "PLANS_TITLE_PRO": "Mejora tu experiencia",
    "PLANS_TITLE_NON_PRO": "Elige tu plan",
    "PLANS_DESC_PRO": "Cambia tu plan actual por uno con más beneficios o mayor duración.",
    "PLANS_DESC_NON_PRO": "Desbloquea funciones premium y personaliza tu perfil como nunca antes.",
    "PLAN_CURRENT_BADGE": "Tu Plan Actual",
    "PLAN_RECOMMENDED_BADGE": "Recomendado",
    "PLAN_SAVE_20": "AHORRA 20%",
    "PLAN_BUTTON_CURRENT": "Plan Actual",
    "PLAN_BUTTON_SWITCH": "Cambiar a este plan",
    "PLAN_BUTTON_CHOOSE": "Elegir Plan",
    "PLAN_SWITCH_NOTE": "El cambio se aplicará al finalizar tu periodo actual",
    "GIFT_TITLE": "Haz un regalo especial",
    "GIFT_DESC": "Regala un mes de PRO a cualquier usuario de MyPlace. El destinatario recibirá una notificación y acceso instantáneo.",
    "GIFT_CARD_TITLE": "PRO GIFT",
    "GIFT_CARD_SUBTITLE": "Un mes de funciones premium",
    "GIFT_USERNAME_LABEL": "Nombre de usuario",
    "GIFT_USERNAME_PLACEHOLDER": "Escribe el @username aquí",
    "GIFT_USERNAME_HINT": "Asegúrate de escribir el nombre de usuario exacto.",
    "GIFT_INFO_TITLE": "¿Qué incluye este regalo?",
    "GIFT_INFO_1": "• Un mes de MyPlace PRO para el usuario indicado.",
    "GIFT_INFO_2": "• Notificación instantánea del regalo.",
    "GIFT_INFO_3": "• Pago único (sin cargos recurrentes para ti).",
    "GIFT_BUTTON": "Confirmar y Pagar ${{ price }}",
    "BADGE_SECURE_PAYMENT": "Pago Seguro",
    "BADGE_AUTO_RENEWAL": "Auto-Renovación",
    "BADGE_CANCEL_ONLINE": "Cancela Online",
    "PLAN_MONTHLY_NAME": "PRO Mensual",
    "PLAN_MONTHLY_PERIOD": "mes",
    "PLAN_MONTHLY_PERIOD_LABEL": "USD / mes",
    "PLAN_MONTHLY_CTA": "Suscribirse",
    "PLAN_MONTHLY_FEATURE_1": "Emojis animados (GIF)",
    "PLAN_MONTHLY_FEATURE_2": "Miniaturas de alta calidad",
    "PLAN_MONTHLY_FEATURE_3": "Subida de GIFs en World Cup",
    "PLAN_MONTHLY_FEATURE_4": "Soporte prioritario",
    "PLAN_YEARLY_NAME": "PRO Anual",
    "PLAN_YEARLY_PERIOD": "año",
    "PLAN_YEARLY_PERIOD_LABEL": "USD / año",
    "PLAN_YEARLY_CTA": "Suscribirse",
    "PLAN_YEARLY_BADGE": "¡Más Popular!",
    "PLAN_YEARLY_FEATURE_1": "Todo lo del plan mensual",
    "PLAN_YEARLY_FEATURE_2": "2 meses gratis incluidos",
    "PLAN_YEARLY_FEATURE_3": "Perfil con badge PRO exclusivo",
    "PLAN_YEARLY_FEATURE_4": "Acceso anticipado a nuevas funciones",
    "PLAN_GIFT_NAME": "Regalar PRO",
    "PLAN_GIFT_PERIOD": "mes",
    "PLAN_GIFT_PERIOD_LABEL": "USD / mes — para un amigo",
    "PLAN_GIFT_CTA": "Regalar",
    "PLAN_GIFT_FEATURE_1": "Un mes de PRO para otro usuario",
    "PLAN_GIFT_FEATURE_2": "El destinatario recibe un aviso",
    "PLAN_GIFT_FEATURE_3": "Ideal como detalle especial",
    "PLAN_GIFT_FEATURE_4": "Pago único, sin renovación",
    "NOTIF_PAYMENT_SUCCESS": "¡Pago exitoso! Estamos activando tu cuenta PRO...",
    "NOTIF_PAYMENT_FAILURE": "El pago no pudo ser procesado.",
    "NOTIF_PAYMENT_PENDING": "Pago pendiente. Se activará cuando sea acreditado.",
    "NOTIF_ACTIVE": "¡Listo! Tu cuenta PRO ya está activa.",
    "NOTIF_VERIFY_TITLE": "Verifica tu email",
    "NOTIF_VERIFY_MSG": "Necesitas verificar tu correo electrónico antes de continuar.",
    "NOTIF_GIFT_USERNAME_EMPTY": "Por favor, ingresa el nombre de usuario al que deseas regalar el plan.",
    "NOTIF_SELF_GIFT": "No puedes regalarte PRO a ti mismo. Para tu cuenta, elige uno de los planes de suscripción.",
    "NOTIF_PAYMENT_ERROR": "Error al iniciar el pago.",
    "NOTIF_SUBSCRIPTION_ERROR": "Error al crear la suscripción.",
    "NOTIF_CANCEL_SUCCESS": "Suscripción cancelada exitosamente.",
    "NOTIF_CANCEL_ERROR": "Error al cancelar la suscripción."
  },
  "RECOV_PASSWORD": {
    "TITLE": "Recuperar Contraseña",
    "DESCRIPTION": "Introduce tu correo y te enviaremos un enlace para que puedas volver a entrar.",
    "EMAIL_LABEL": "Email de tu cuenta",
    "EMAIL_PLACEHOLDER": "ejemplo@email.com",
    "BUTTON": "Enviar Enlace",
    "BUTTON_LOADING": "Enviando...",
    "BACK_TO_LOGIN": "← Volver al inicio de sesión",
    "ERROR_EMAIL_EMPTY": "Por favor, ingresa tu correo electrónico.",
    "SUCCESS_MESSAGE": "Te hemos enviado un correo con las instrucciones.",
    "ERROR_GENERIC": "No pudimos procesar tu solicitud."
  },
  "REPORT_MODAL": {
    "TITLE": "REPORTAR",
    "SUBTITLE": "Ayúdanos a mantener MyPlace seguro",
    "SUCCESS_TITLE": "¡Reporte enviado!",
    "SUCCESS_DESC": "Gracias por tu reporte. Nuestro equipo de moderación lo revisará lo antes posible.",
    "REPORTED_CONTENT_LABEL": "Contenido reportado:",
    "REASON_LABEL": "Motivo del reporte",
    "REASON_PLACEHOLDER": "Selecciona un motivo...",
    "DESCRIPTION_LABEL": "Detalles adicionales (opcional)",
    "DESCRIPTION_PLACEHOLDER": "Danos más contexto sobre el problema...",
    "BUTTON": "Enviar Reporte",
    "BUTTON_LOADING": "Enviando...",
    "REASON_SPAM": "Spam",
    "REASON_HARASSMENT": "Acoso o bullying",
    "REASON_INAPPROPRIATE": "Contenido inapropiado",
    "REASON_MISINFORMATION": "Desinformación",
    "REASON_COPYRIGHT": "Violación de derechos de autor",
    "REASON_HATE_SPEECH": "Discurso de odio",
    "REASON_OTHER": "Otro",
    "ERROR_ALREADY_REPORTED": "Ya has reportado este contenido anteriormente.",
    "ERROR_GENERIC": "Hubo un error al enviar el reporte. Por favor, inténtalo de nuevo."
  },
  "SHARE_MODAL": {
    "TITLE": "COMPARTIR",
    "SUBTITLE": "¡Invita a tus amigos a jugar!",
    "COPY": "COPIAR",
    "COPIED": "COPIADO",
    "COPY_SUCCESS_MSG": "Link listo para compartir",
    "SHARE_TEXT": "¡Mira este juego en MyPlace! 🎮"
  },
  "RESET_PASSWORD": {
    "TITLE": "Nueva Contraseña",
    "DESCRIPTION": "Establece tu nueva contraseña de acceso.",
    "REDIRECTING": "Redirigiendo al login...",
    "BACK_TO_HOME": "Volver al inicio",
    "EMAIL_LABEL": "Email",
    "NEW_PASSWORD_LABEL": "Nueva Contraseña",
    "CONFIRM_PASSWORD_LABEL": "Confirmar Contraseña",
    "SHOW_PASSWORD": "Mostrar contraseña",
    "HIDE_PASSWORD": "Ocultar contraseña",
    "BUTTON": "Restablecer Contraseña",
    "BUTTON_LOADING": "Guardando...",
    "ERROR_INVALID_LINK": "El enlace de restablecimiento no es válido o ha expirado.",
    "ERROR_PASSWORD_MISMATCH": "Las contraseñas no coinciden.",
    "ERROR_PASSWORD_LENGTH": "La contraseña debe tener al menos 6 caracteres.",
    "SUCCESS_MESSAGE": "Contraseña restablecida con éxito.",
    "ERROR_GENERIC": "Error al restablecer la contraseña."
  },
  "SETUP_USERNAME": {
    "TITLE_FIRST_TIME": "Elige tu nombre de usuario",
    "TITLE_CHANGE": "Cambiar nombre de usuario",
    "DESC_FIRST_TIME": "Este será tu identidad pública en la plataforma.<br>Podrás cambiarlo más adelante subiendo a <span class=\"text-emerald-400 font-semibold\">PRO</span>.",
    "DESC_CHANGE": "Cambiar tu username es una función exclusiva para <span class=\"text-emerald-400 font-semibold\">usuarios Pro</span>.",
    "USERNAME_LABEL": "Nombre de usuario:",
    "USERNAME_PLACEHOLDER": "your_user",
    "USERNAME_HINT": "3–20 caracteres · letras, números y _ permitidos",
    "ERROR_REQUIRED": "El nombre de usuario es requerido.",
    "ERROR_MIN_LENGTH": "Mínimo 3 caracteres.",
    "ERROR_PATTERN": "Solo letras, números y guiones bajos.",
    "ERROR_TAKEN": "Este nombre de usuario ya está en uso.",
    "AVAILABLE": "¡Disponible!",
    "PRO_ONLY_TEXT": "Solo los usuarios Pro pueden cambiar su nombre de usuario.",
    "PRO_UPGRADE_LINK": "Subir a Pro",
    "BUTTON_CONTINUE": "Continuar",
    "BUTTON_CHANGE": "Cambiar Usuario (Pro)",
    "BUTTON_LOADING": "Guardando...",
    "BACK_TO_SETTINGS": "Volver a ajustes de cuenta",
    "ERROR_PRO_REQUIRED": "Necesitas una cuenta Pro para cambiar tu nombre de usuario.",
    "ERROR_INVALID_OR_TAKEN": "El nombre de usuario no es válido o ya está en uso.",
    "ERROR_GENERIC": "Error al guardar. Intenta nuevamente."
  },
  "SEARCH": {
    "FILTER_ALL": "Todo",
    "FILTER_PROJECTS": "Proyectos",
    "FILTER_USERS": "Usuarios",
    "SORT_CREATION_DATE": "Fecha de creación",
    "SORT_LAST_UPDATE": "Última actualización",
    "SORT_MOST_RECENT": "Más recientes",
    "SORT_OLDEST": "Más antiguos",
    "RESULTS_HEADER": "Resultados para \"{{ query }}\"",
    "RESULTS_COUNT": "({{ count }} resultados)",
    "SEARCHING": "Buscando...",
    "SECTION_PROJECTS": "Proyectos",
    "SECTION_USERS": "Usuarios",
    "ITEMS_COUNT": "{{ count }} items",
    "NO_RESULTS_TITLE": "Sin resultados para \"{{ query }}\"",
    "NO_RESULTS_HINT": "Prueba con otros filtros o un término diferente.",
    "THUMBNAIL_ALT": "Miniatura",
    "PROFILE_ALT": "Imagen de perfil",
    "USER_CARD_VIEW_PROFILE": "Ver perfil",
    "USER_SUBSCRIBERS_NONE": "Sin suscriptores",
    "USER_SUBSCRIBERS_ONE": "1 suscriptor",
    "USER_SUBSCRIBERS_MANY": "{{ count }} suscriptores"
  },
  "TERMS": {
    "BACK_HOME": "Volver al inicio",
    "TITLE": "Términos de Servicio",
    "LAST_UPDATED": "Última actualización: Abril 2026",
    "SECTION_1_TITLE": "1. Minijuegos y Contenido",
    "SECTION_1_HTML": "Nuestra plataforma permite a los usuarios crear y compartir minijuegos interactivos, incluyendo <b>World Cup (Torneos)</b>, <b>Tierlists</b>, <b>Top Picks</b> y más. Al subir contenido, garantizas que posees los derechos necesarios o que el uso de los mismos cumple con las normativas locales.",
    "SECTION_2_TITLE": "2. Contenido \"Súbido de Tono\" (Mature)",
    "SECTION_2_INTRO": "Entendemos que el arte y el entretenimiento pueden tener diferentes matices. Se permite contenido con temáticas maduras o \"súbidas de tono\" siempre y cuando:",
    "SECTION_2_ITEM_1": "Se utilicen las etiquetas (tags) de advertencia adecuadas.",
    "SECTION_2_ITEM_2": "No infrinja leyes internacionales (no se permite contenido ilegal de ningún tipo).",
    "SECTION_2_ITEM_3": "No sea puramente gratuito u ofensivo hacia minorías o colectivos.",
    "SECTION_3_TITLE": "3. Chat y Comunidad",
    "SECTION_3_INTRO": "Ponemos a tu disposición un sistema de chat en vivo con <b>emojis personalizados</b>. Al usarlo te comprometes a:",
    "SECTION_3_ITEM_1": "No acosar, intimidar o faltar al respeto a otros usuarios.",
    "SECTION_3_ITEM_2": "No realizar spam de mensajes o emojis.",
    "SECTION_3_ITEM_3": "No compartir enlaces maliciosos.",
    "SECTION_4_TITLE": "4. Responsabilidad",
    "SECTION_4_HTML": "<b>MyPlace</b> se reserva el derecho de eliminar cualquier contenido o suspender cuentas que violen estos términos sin previo aviso. Eres el único responsable del impacto de tus creaciones en la comunidad.",
    "SECTION_5_TITLE": "5. Derechos de Autor (DMCA)",
    "SECTION_5_INTRO_HTML": "Respetamos los derechos de propiedad intelectual. Si consideras que tu contenido ha sido copiado de forma que constituya una infracción de derechos de autor, por favor notifícalo a <a href=\"mailto:support@myplacetoday.com\" class=\"text-blue-600 dark:text-blue-400 hover:underline\">support@myplacetoday.com</a> con la siguiente información:",
    "SECTION_5_ITEM_1": "Identificación de la obra protegida.",
    "SECTION_5_ITEM_2": "Identificación del contenido infractor y su ubicación en la plataforma.",
    "SECTION_5_ITEM_3": "Tu información de contacto (nombre, correo electrónico, teléfono).",
    "SECTION_5_ITEM_4": "Una declaración de buena fe de que el uso no está autorizado.",
    "SECTION_5_ITEM_5": "Una declaración, bajo pena de perjurio, de que la información es precisa.",
    "SECTION_5_ITEM_6": "Tu firma física o electrónica.",
    "SECTION_5_OUTRO": "Responderemos a todas las notificaciones DMCA válidas y tomaremos las medidas apropiadas, incluyendo la eliminación del contenido infractor.",
    "SECTION_6_TITLE": "6. Contacto",
    "SECTION_6_TEXT": "Para cualquier consulta sobre estos términos, puedes contactarnos en:"
  },
  "CONFIRM_DIALOG": {
    "TITLE_DELETE": "Confirmar eliminar",
    "MESSAGE_DELETE": "¿Estás seguro de que deseas eliminar el item?",
    "CONFIRM": "Eliminar",
    "CANCEL": "Cancelar"
  },
  "VERIFY_EMAIL": {
    "TITLE_PENDING": "Verifica tu correo",
    "DESC_PENDING": "Te enviamos un enlace de verificación a tu email.<br>Revisa tu bandeja de entrada y haz clic en el enlace.",
    "RESEND_BUTTON": "Reenviar correo",
    "RESEND_BUTTON_LOADING": "Enviando...",
    "RESEND_COOLDOWN": "Reenviar en {{ seconds }}s",
    "SPAM_HINT": "Revisa también tu carpeta de spam.",
    "TITLE_SUCCESS": "¡Email verificado!",
    "TITLE_ALREADY_VERIFIED": "Ya estás verificado",
    "DESC_SUCCESS": "Tu cuenta está activa. Ya puedes usar la plataforma.",
    "CONTINUE_BUTTON": "Continuar",
    "TITLE_EXPIRED": "Enlace expirado",
    "DESC_EXPIRED": "El enlace de verificación expiró. Solicita uno nuevo.",
    "REQUEST_NEW_LINK": "Solicitar nuevo enlace",
    "TITLE_INVALID": "Enlace inválido",
    "DESC_INVALID": "El enlace no es válido. Inicia sesión y solicita un nuevo correo de verificación.",
    "GO_HOME_BUTTON": "Ir al inicio"
  },
  "VIEW_FORM": {
    "DESCRIPTION_LABEL": "Descripción:",
    "NO_DESCRIPTION": "Sin descripción",
    "CREATED_BY": "Creado por:",
    "PROFILE_ALT": "Imagen de perfil",
    "THUMBNAIL_ALT": "Miniatura",
    "LAST_UPDATE_LABEL": "Última actualización:",
    "LIKE_ARIA": "Dar like",
    "UNLIKE_ARIA": "Quitar like",
    "COOLDOWN_TOOLTIP": "Podrás quitar el like en {{ time }}",
    "REPORT_TITLE": "Reportar",
    "START": "Comenzar",
    "START_WORLD_CUP": "Comenzar World Cup",
    "HIDE_RANKINGS": "Ocultar clasificaciones",
    "SHOW_RANKINGS": "Mostrar clasificaciones",
    "HIDE_ITEMS": "Ocultar items",
    "SHOW_ITEMS": "Mostrar items",
    "HIDE_COMMENTS": "Ocultar comentarios",
    "SHOW_COMMENTS": "Mostrar comentarios",
    "WORLD_CUP_SIZE_TITLE": "Selecciona el tamaño de la World Cup",
    "WORLD_CUP_START": "Comenzar",
    "WORLD_CUP_CANCEL": "Cancelar",
    "ROUND_OPTION": "Ronda de {{ size }}",
    "NOTIF_LOGIN_TITLE": "Inicia sesión",
    "NOTIF_LOGIN_MSG": "Debes iniciar sesión para realizar esta acción.",
    "NOTIF_VERIFY_TITLE": "Verifica tu email",
    "NOTIF_VERIFY_MSG": "Necesitas verificar tu correo electrónico antes de continuar.",
    "ERROR_LOAD": "Error al cargar el proyecto",
    "DATE_UNAVAILABLE": "Fecha no disponible"
  }
}
